import { useTranslation } from 'react-i18next';
import { Select } from '@knack/asterisk-react';

import { type BooleanField } from '@/types/schema/fields';
import { type InputValueType } from '@/components/data-table/display/header/filters/Filters';

export function BooleanInputValue({ defaultValue, onChange, field }: InputValueType<BooleanField>) {
  const [t] = useTranslation();

  const options: string[] = [];

  switch (field.format?.format) {
    case 'on_off':
      options.push('on', 'off');
      break;
    case 'true_false':
      options.push('true', 'false');
      break;
    case 'yes_no':
      options.push('yes', 'no');
      break;
    default:
      options.push('yes', 'no');
  }

  return (
    <Select
      onValueChange={(newValue) => {
        onChange(newValue);
      }}
      defaultValue={defaultValue}
    >
      <Select.Trigger
        placeholder={t('components.data_table.filtering.select')}
        className="w-full rounded-lg"
        data-testid="field-boolean"
      />
      <Select.Content>
        {options?.map((operator) => (
          <Select.Item key={operator} value={operator}>
            {t(`components.data_table.filtering.boolean.${operator}`)}
          </Select.Item>
        ))}
      </Select.Content>
    </Select>
  );
}
